(function($) {

  $(function() {
    var deviceSP = OH.browserInfo.isiOS || OH.browserInfo.isAndroid;
    var deviceSPMediaQuery = window.matchMedia('(max-width:600px)').matches;

    // inline script 実行用
    if (!!window.firstTask && typeof window.firstTask == "function") {
      window.firstTask();
    }

    // header stickey
    $('BODY > HEADER, .l-fronthead > HEADER').each(function() {
      OH.settings.headerControl.stickey($(this));
    });

    // header text color when over mainVisual 
    OH.settings.headerControl.menuOverMainVisual('.l-header', '.mainVisual:not(#featureMainVisual)', '#l-utility');

    // height 揃え
    $('.c-cols.is-list').each(function() {
      OH.settings.heightControl.permanentHeightFix($(this), "c-cols__col", 2, 3);
    });
    $('.l-shop_list.c-cols').each(function() {
      OH.settings.heightControl.permanentHeightFix($(this), "l-shop_list__item", 2, 4);
    });
    $('.c-vcols.is-eventlist').each(function() {
      OH.settings.heightControl.permanentHeightFix($(this), "c-vcols__col", 1, 3);
    });

    $('.c-extendBlock .c-cols').each(function() {
      OH.settings.heightControl.permanentHeightFix($(this), "l-shop_list__item", 2, 3);
    });
    

    $('.l-header__nav__sp').each(function() {
      OH.settings.menuControl.spMenu($(this), "c-spnav", "#l-utility", "l-header__nav__sp", '.l-header__logo')
    });

    //ハンバーガーメニュー幅だったらフルサイズヘッダ用の言語セレクタ消す
    if(window.matchMedia('(max-width:1100px)').matches){
      $('.l-header__nav__pc .pcmask').remove();
    }

    $('.l-header__nav__list__item').each(function() {
      OH.settings.headerControl.currentClassAdd($(this), 'a');
    });

    //ショップ一覧の処理
    // $('.shop_menu .shop_menu__item:eq(0)').addClass('current_pages');
    $('.shop_menu__item').each(function() {
      OH.settings.headerControl.currentClassAdd($(this), 'a', true);
    });
    // general_carousel
    $('#l-mainVisual').each(function() {
      new OH.settings.xfadeControl.ElementalChanger($(this), "l-mainVisual");
      //	OH.settings.carouselControl.general($(this), "l-mainVisual");
    });

    // vue_rendering
    $('[data-rendering-type]').each(function() {
      OH.settings.vueControl[$(this).attr('data-rendering-type')]($(this));
    });

    // info_viewer
    $('.c-infoViewer').each(function() {
      OH.infoViewer($(this), 'c-infoViewer');
    });

    // crossfade
    $('[data-xfade]').each(function() {
      OH.settings.xfadeControl.crossFade($(this));
    });

    // standby_intoview
    $('[data-intoview]').each(function() {
      OH.settings.standbyControl.intoview($(this));
    });

    // display_controller
    $('[data-display-size]').each(function() {
      OH.displayController($(this));
    });

    // modal_controller
    $('[data-modal-controlled]').each(function() {
      OH.modalController.staticModal($(this));
    });

    // modal_controller
    $('A[href^="#"]').each(function() {
      OH.anchorController($(this));
    });

    // トップページ：splash動画とカルーセル
    //OH.settings.frontpageControl('l-fronthead', 'l-hero', '.l-header__logo');

    // share_button
    $('.c-pageHeader__share').each(function() {
      $(this).on("click", function() {
        $(this).toggleClass("is-open");
      });
    });

    $('.c-datepicker').each(function() {
      OH.settings.datepickerControl.init($(this));
    });


    $('[data-event-end]').each(function() {
      if (new Date().getTime() > new Date($(this).data("eventEnd")).getTime()) {
        $(this).removeClass("is-hidden");
        $(this).insertAfter(".c-pageHeaderv");
      }
    });
    
    $('.is-list .c-cols__col,.is-list .c-vcols__col').each(function(){
      OH.settings.colsControl.boxVisible($(this));
    });
    $('.l-feature__list__item').each(function(){
      OH.settings.colsControl.boxVisible($(this));
    });

    $('[placeholder]').each(function() {
      OH.attributeTranslation($(this), "placeholder");
    });

    $('.c-scalableFigure').each(function() {
      OH.settings.scalabelFigureControl.setFigure($(this));
    });
    $('[data-location-figure]').each(function() {
      OH.settings.scalabelFigureControl.setModal($(this));
    });

    //footer OH.settings.footerControl.js
    $('.l-footer__copyright').each(function() {
      OH.settings.footerControl.copylightUpper($(this));
    });


    //説明文の oo文字以上 は三点リーダ
    // $('.c-thumbnail__item.is-summary').each(function(){
    //   OH.settings.lineClamp.strengLength($(this),30);
    // });

    //2行の終わりでclamp 三点リーダ
    // eachでのwhile処理が非常に重く、ブラウザ固まるので使わない
    // $('.is-list .c-thumbnail__item.is-catchcopy').each(function(){
    //   OH.settings.lineClamp.heightClamp($(this));
    // });


    $('[data-search-trigger]').each(function(){
        OH.settings.menuControl.headerTogglBox($(this),'search');
    });

		$('[data-language-trigger]').each(function(){
      OH.settings.menuControl.headerTogglBox($(this),'language');
    });


    /**
     * トップカルーセル内　1行ずつの出し分け
     */
    var atfirst = true;
    var carouselCallBackEvent = function topTexet() {
      if (deviceSPMediaQuery) {
        $('.mainVisual__sp a .mainVisual__sp__item__category span').each(function() {
          OH.settings.topText.oneLineUp($(this), $('.mainVisual__sp__item__category span'), 1)
        });
        $('.mainVisual__sp a .mainVisual__sp__item__catchcopy__line span').each(function() {
          OH.settings.topText.oneLineUp($(this), $('.mainVisual__sp__item__catchcopy__line span'), 1)
        });
      } else if (!deviceSPMediaQuery) {
        $('.mainVisual__pc a .mainVisual__pc__item__category span').each(function() {
          OH.settings.topText.oneLineUp($(this), $('.mainVisual__pc__item__category span'), 1)
        });
        $('.mainVisual__pc a .mainVisual__pc__item__catchcopy__line span').each(function() {
          OH.settings.topText.oneLineUp($(this), $('.mainVisual__pc__item__catchcopy__line span'), 1)
        });
        $('.mainVisual__pc a .mainVisual__pc__item__read__line.is-line_1 span').each(function() {
          OH.settings.topText.oneLineUp($(this), $('.mainVisual__pc__item__read__line.is-line_1 span'), 6)
        });
        $('.mainVisual__pc a .mainVisual__pc__item__read__line.is-line_2 span').each(function() {
          OH.settings.topText.oneLineUp($(this), $('.mainVisual__pc__item__read__line.is-line_2 span'), 6)
        });
      }
    };

    var carouselCallBackEventPrev = function topTexet() {
      if (deviceSPMediaQuery) {
        $('.mainVisual__sp a .mainVisual__sp__item__category span').each(function() {
          OH.settings.topText.hideAnimation($(this), $('.mainVisual__sp__item__category span'), 1)
        });
        $('.mainVisual__sp a .mainVisual__sp__item__catchcopy__line span').each(function() {
          OH.settings.topText.hideAnimation($(this), $('.mainVisual__sp__item__catchcopy__line span'), 1)
        });
      } else if (!deviceSPMediaQuery) {
        $('.mainVisual__pc a .mainVisual__pc__item__category span').each(function() {
          OH.settings.topText.hideAnimation($(this), $('.mainVisual__pc__item__category span'), 1)
        });
        $('.mainVisual__pc a .mainVisual__pc__item__catchcopy__line span').each(function() {
          OH.settings.topText.hideAnimation($(this), $('.mainVisual__pc__item__catchcopy__line span'), 1)
        });
        $('.mainVisual__pc a .mainVisual__pc__item__read__line.is-line_1 span').each(function() {
          OH.settings.topText.hideAnimation($(this), $('.mainVisual__pc__item__read__line.is-line_1 span'), 1)
        });
        $('.mainVisual__pc a .mainVisual__pc__item__read__line.is-line_2 span').each(function() {
          OH.settings.topText.hideAnimation($(this), $('.mainVisual__pc__item__read__line.is-line_2 span'), 1)
        });
      }
    };

    $('.mainVisual__sp').on('drag.owl.carousel translate.owl.carousel', carouselCallBackEventPrev);
    $('.mainVisual__sp').on('translated.owl.carousel initialized.owl.carousel', carouselCallBackEvent);
    $('.mainVisual__pc').on('drag.owl.carousel translate.owl.carousel', carouselCallBackEventPrev);
    $('.mainVisual__pc').on('translated.owl.carousel initialized.owl.carousel', carouselCallBackEvent);

    //カルーセルに連動してグローバルナビのテキスト色などを変更
    OH.carouselLinkage(
      'screen and (min-width: 1101px)',
      [
        {
          selector: '.l-header:not(.is-out_main_visual) .l-header__nav__list__item a { color: ',
          change: true
        },
        {
          selector: '.l-header:not(.is-out_main_visual) .l-header__nav__list__item a svg { fill: ',
          change: true
        },
        {
          selector: '.l-header:not(.is-out_main_visual) .l-header__nav__list__item a:hover svg { fill: ',
          change: true
        },
        {
          selector: '.l-header:not(.is-out_main_visual) .l-header__nav__list__item.is-search a:hover svg { fill: #28b06e',
          change: false
        },
        {
          selector: '.l-header:not(.is-out_main_visual) .l-header__nav__list__item.is-info a:hover svg { fill: #28b06e',
          change: false
        },
        {
          selector: '.l-header:not(.is-out_main_visual) .l-header__nav__list__item.is-search { border-color: ',
          change: true
        },
        {
          selector: '.owl-theme .owl-dots .owl-dot span { border-color: ',
          change: true
        }
      ],
      '.owl-item.active .mainVisual__pc__item',
      'data-color'
    );

    //全体フロアマップ画像の言語ごとの書き換え
    $('[data-allmap-images]').each(function(){
      OH.settings.scalabelFigureControl.indexMapLang($(this));
    });

    /**
     * 暫定処理 SPで　en の ときだけ feature系フォントサイズ落とす
     */
    if(deviceSPMediaQuery){
      try{
        // window.onload(function(){
        //   var langMode = WOVN.io.getCurrentLang();// wovnが使えるかここで判断
        // });
        window.addEventListener('wovnLangChanged', function(evt) {
          var langMode = WOVN.io.getCurrentLang().code;
          if(langMode == 'en'){
            $('.mainVisual__sp__item__catchcopy__line').each(function(){
              $(this).css({
                'font-size':'30px',
                'height': '38px',
                'margin-bottom' : '8px'
              });
            });
            $('.l-feature__list__item__catchcopy').each(function(){
              $(this).css({
                'font-size':'36px',
                'margin-top': '26%'
              });
            });
            $('.oc-featureMainVisual__catchcopy').each(function(){
              $(this).css({
                'font-size': '30px',
                'line-height': '1.4'
              });
            });
          } else {
            $('.mainVisual__sp__item__catchcopy__line').each(function(){
              $(this).css({
                'font-size':'',
                'height': '',
                'margin-bottom' : ''
              });
            });
            $('.l-feature__list__item__catchcopy').each(function(){
              $(this).css({
                'font-size':'',
                'margin-top': ''
              });
            });
            $('.oc-featureMainVisual__catchcopy').each(function(){
              $(this).css({
                'font-size': '',
                'line-height': ''
              });
            });
              
          }
        });
      }catch(errorMessage){
        var langMode = 'ja';
        console.warn('wovn load error. this message by local script.');
      }
    }

    //親要素の幅に応じてテキストを縮小
    if (document.getElementsByClassName('js-shrinktext')[0] != null) {
      OH.ShrinkText(document.getElementsByClassName('js-shrinktext'), 22, 775, '(max-width: 839px)');
    }

    //ボトムナビ
    if (!window.matchMedia('(min-width:1101px)').matches) {
      OH.initBottomNavi({
        elemClassName: 'js-navi-bottom',
        option: {
          onClassName: 'is-on',
          delayTime: 500
        }
      });
    }
  });
})(jQuery);
